export const BASE_URL = 'https://backend.billswift.cloud/';
//export const BASE_URL = 'http://localhost:3000';
